export const safeHref = (url) => {
    if (typeof url !== 'string') {
        return null;
    }
    return /^https?:\/\//i.test(url.trim()) ? url.trim() : null;
};

export const isValidValue = (value) => {
    if (value === null || value === undefined) {
        return false;
    }
    if (typeof value === 'string' && value.trim() === '') {
        return false;
    }
    if (Array.isArray(value) && value.length === 0) {
        return false;
    }
    return true;
}
